<script lang="ts">
    import { gwI18nContextToken } from "@/context_tokens";
    import CustomerNameFormSelect from "@apps/reviews/components/CustomerNameFormSelect.svelte";
    import ReviewsTextArea from "@apps/reviews/components/ReviewsTextArea/ReviewsTextArea.svelte";
    import ReviewsTextInput from "@apps/reviews/components/ReviewsTextInput/ReviewsTextInput.svelte";
    import FormManager from "@lib/FormManager/FormManager";
    import FormManagerController from "@lib/FormManager/FormManagerController.svelte";
    import FormManagerProvider from "@lib/FormManager/FormManagerProvider.svelte";
    import { getTypedContext } from "@lib/svelte-typed-context";

    import FormLayout from "@components/FormLayout/FormLayout.svelte";
    import FormLayoutItem from "@components/FormLayout/FormLayoutItem.svelte";

    export let formManager: FormManager;
    export let showTitleInput: boolean;
    export let isAuthenticated: boolean;
    export let isCustomerNameChoiceEnabled: boolean;

    const gwI18n = getTypedContext(gwI18nContextToken);

    const t_title_input_label$ = gwI18n.selectT(
        "reviews.ReviewsFormModalWidget",
        "title_input_label"
    );
    const t_title_input_placeholder$ = gwI18n.selectT(
        "reviews.ReviewsFormModalWidget",
        "title_input_placeholder"
    );
    const t_body_input_label$ = gwI18n.selectT(
        "reviews.ReviewsFormModalWidget",
        "body_input_label"
    );
    const t_body_input_placeholder$ = gwI18n.selectT(
        "reviews.ReviewsFormModalWidget",
        "body_input_placeholder"
    );
</script>

<FormManagerProvider {formManager}>
    <FormLayout rowGap="20px">
        {#if isCustomerNameChoiceEnabled}
            <FormManagerController name="customerDisplayNamePolicy" let:field>
                <FormLayoutItem
                    errors={field.errors || []}
                    namespace="reviews.ReviewsFormModalWidget"
                >
                    <CustomerNameFormSelect
                        namespace="reviews.ReviewsFormModalWidget"
                        {isAuthenticated}
                        value={field.value}
                        on:change={field.onChange}
                    />
                </FormLayoutItem>
            </FormManagerController>
        {/if}
        {#if showTitleInput}
            <FormManagerController name="title" let:field>
                <FormLayoutItem
                    errors={field.errors || []}
                    namespace="reviews.ReviewsFormModalWidget"
                >
                    <ReviewsTextInput
                        aria-label={$t_title_input_label$}
                        placeholder={$t_title_input_placeholder$}
                        name={field.name}
                        value={field.value}
                        on:change={(val) => {
                            field.onChange(val);
                        }}
                    />
                </FormLayoutItem>
            </FormManagerController>
        {/if}
        <FormManagerController name="body" let:field>
            <FormLayoutItem
                errors={field.errors || []}
                namespace="reviews.ReviewsFormModalWidget"
            >
                <ReviewsTextArea
                    ariaLabel={$t_body_input_label$}
                    placeholder={$t_body_input_placeholder$}
                    name={field.name}
                    value={field.value}
                    rows={5}
                    on:change={field.onChange}
                />
            </FormLayoutItem>
        </FormManagerController>
    </FormLayout>
</FormManagerProvider>
